import { render, staticRenderFns } from "./el_table_columntalet.vue?vue&type=template&id=18bf0759&scoped=true"
import script from "./el_table_columntalet.vue?vue&type=script&lang=js"
export * from "./el_table_columntalet.vue?vue&type=script&lang=js"
import style0 from "./el_table_columntalet.vue?vue&type=style&index=0&id=18bf0759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf0759",
  null
  
)

export default component.exports